import axios from "axios";

/* ---------------------工资条------------------- */

export function functionTrigger(data) {
  return axios.post(
    process.env.VUE_APP_BASE_API + "/chaos/order/bmsOrderFunctionTrigger",
    data
  );
}

export function orderGetByIdFromBack(data) {
  return axios.post(
    process.env.VUE_APP_BASE_API +
      "/chaos/order/getByIdFromBack?orderCode=" +
      data.orderCode,
    data
  );
}

/**
 * 验证码
 * @param {*} data 
 * @returns 
 */
export function sendZRBXVerifyCode(data) {
  return axios.post(
    process.env.VUE_APP_BXX_API +
      "/chaos/compliance/order/sendZRBXVerifyCode",
    data
  );
}


/**
 * 保单查询验证
 * @param {*} data 
 * @returns 
 */
export function queryVerifToken(data) {
  return axios.post(
    process.env.VUE_APP_BXX_API +
      "/chaos/compliance/order/queryVerifToken",
    data
  );
}

/**
 * 保单查询列表
 * @param {*} data 
 * @returns 
 */
export function queryAllChaosOrderList(data) {
  return axios.post(
    process.env.VUE_APP_BXX_API +
      "/chaos/compliance/order/queryAllChaosOrderList",
    data
  );
}

/**
 * 保单详情
 * @param {*} data
 * @returns
 */
 export function queryChaosOrderDetail(data) {
  return axios.post(
    process.env.VUE_APP_BXX_API +
      "/chaos/compliance/order/queryChaosOrderDetail",
    data
  );
}
